/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/9/26
 * Time: 上午11:29
 */

export default {
  name: 'link',
  type: 'button',
  icon: 'ios-link',
  description: '超链接',
  handleToolbar: (quill, content) => {
    // quill.format('link', content)
  }
}



// WEBPACK FOOTER //
// ./src/components/quill/toolbar/link.js